import { stateUi } from '@infinitro/config';
import { get } from 'svelte/store';
import flushAssets from './flush';
import fomoAssets from './fomoio';
const allAssets = {
    classic: flushAssets,
    elevated: fomoAssets
};
const assetSet = get(stateUi).vip.assetSet ?? 'classic';
const assets = allAssets[assetSet] || allAssets.classic;
export default assets;
